import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { PrivateAxios } from '../../environment/AxiosInstance';
import { ErrorMessage, SuccessMessage } from '../../environment/ToastMessage';

function DeleteProjectModal({ show, handleClose, projectId, onSuccess, refreshTasks  }) {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!projectId) return;

  //  if (!window.confirm("Are you sure you want to delete this project?")) return;

    setLoading(true);
    try {
      const res = await PrivateAxios.delete(`/project/delete/${projectId}`);
      if (res.data?.success) {
        SuccessMessage("Project deleted successfully!");
        if (onSuccess) onSuccess(); // refresh list in parent
         refreshTasks(); 
        handleClose();
      } else {
        ErrorMessage(res.data?.message || "Failed to delete project!");
      }
    } catch (err) {
      ErrorMessage(err.response?.data?.message || "Server error!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton className="gth-light-red-bg">
        <Modal.Title className="gth-text-danger">Delete Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="delete-confirm-wrap text-center">
          <div className="delete-confirm-icon mb-3 mt-2">
            <img
              src={process.env.PUBLIC_URL + 'assets/images/delete-warning.svg'}
              alt="Warning"
              className="img-fluid"
            />
          </div>
          <h4 className="text-muted">Are you sure?</h4>
          <p className="text-muted">
            Do you really want to delete this record? This process cannot be undone.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className='justify-content-center'>
        <button className='btn btn-secondary' onClick={handleClose} disabled={loading}>
          Cancel
        </button>
        <button className='btn btn-exp-red' onClick={handleDelete} disabled={loading}>
          {loading ? "Deleting..." : "Delete"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteProjectModal;
